export const tableDataMode = {
  CLIENT_SIDE: 'clientSideData',
  SERVER_SIDE: 'serverSideData'
}

export const documentEvents = {
  CELL_CHANGED: 'Document:cellChanged',
  DOCUMENT_UNSAVED: 'Document:documentUnsaved',
  MULTIPLE_DOCUMENTS_UNSAVED: 'Document:multipleDocumentsUnsaved',
  DOCUMENT_READY: 'Document:documentReady',
  EMPTY_DOCUMENT_CREATED: 'Document:emptyDocumentCreated',
  DOCUMENT_CRUD: 'Document:documentCrud',
  DATA_REFRESH_REQUESTED: 'Document:dataRefreshRequested',
  DOCUMENT_SAVE_REQUESTED: 'Document:documentSaveRequested',
  DOCUMENT_REFRESHED: 'Document:documentRefreshed',
  MULTISAVE_REQUESTED: 'Document:multisaveRequested',
  DOCUMENT_TAB_CLOSED: 'Document:documentTabClosed',
  DOCUMENT_DETAIL_TAB_CHANGED: 'Document:documentDetailTabChanged'
}

export const MAIN_SECTION_ID = 'DEFINITION'

export const FIELD_POSITION_KEY = 'position'

export const defaultColumnDefs = {
  sortable: true,
  resizable: true,
  // lockPinned: true, // if true user cannot choose lock columns
  suppressMovable: true,
  floatingFilter: true,
  tooltipComponent: 'customTooltip'
}

export const defaultGridOptions = {
  pagination: true,
  suppressRowClickSelection: true,
  stopEditingWhenGridLosesFocus: false,
  suppressColumnVirtualisation: true,
  suppressDragLeaveHidesColumns: true
}

export const QUICK_FILTER_INPUT =
  '.ublique-tabs-content .header-search input.bx--search-input'
export const QUICK_FILTER_DELETE =
  '.ublique-tabs-content .header-search button.bx--search-close'

export const HIDDEN_COLUMNS = 'hiddenColumns'

export const GENERAL_CONFIG = '__config'

export const TABLE_ITEMS_PER_PAGE = 10

export const DETAIL_TABLE_ITEMS_PER_PAGE = 5

export const AGGRID_FILTERS_MAP = {
  text: 'agTextColumnFilter',
  set: 'agSetColumnFilter'
}

export const LAZY_PLACEHOLDER = 'lazy'

export const detailsType = {
  GRID: 'grid',
  SERVER_GRID: 'servergrid'
}

export const LAZY_LOADED_TYPES = [detailsType.SERVER_GRID]

export const FIRST_COLUMN_TYPE = 'none'

export const LOCKED_COLUMNS_KEY = 'lockedColumns'

export const LOCKED_COLUMNS_KEY_OUTPUT = 'lockedColumnsOutput'
